import React, { Component } from 'react'
import WidgetContainer from '../../containers/WidgetContainer'
import LeafletsContainer from './LeafletsContainer'
import type { LeafletsWidgetProps } from '../Types'
import { NewLabelDesktop } from '../../utils/NewLabelDesktop'
import { NewLabelMobile } from '../../utils/NewLabelMobile'
import { DEVICES } from '../../../constants'
import { sendEvent } from '../../utils/googleAnalytics'

export default class Leaflets extends Component<LeafletsWidgetProps> {
  handleHeadlineClick = () =>
    sendEvent(this.props.googleAnalytics, {
      category: 'Click',
      action: 'Letáky',
      label: 'Open'
    })
  handleAnchorClick (event, location, name, id) {
    event.preventDefault()

    const {
      googleAnalytics
    } = this.props

    const isGoogleAnalyticsSet = typeof googleAnalytics !== 'undefined'

    const purchaseFieldObject = {
      id,
      name,
      category: 'letaky.promotheus.cz'
    }

    if (isGoogleAnalyticsSet) {
      sendEvent(googleAnalytics, {
        category: 'Click',
        action: 'Letáky',
        label: `${name} - ${location}`
      })
      googleAnalytics.handlePurchaseEvent(purchaseFieldObject).then(() => {
        document.location.href = location
      }).catch(() => {
        document.location.href = location
      })
    } else {
      document.location.href = location
    }
  }

  render () {
    const {
      activeDynamicLayout,
      isOpening,
      isOpen,
      handleToggleContent,
      widget,
      googleAnalytics,
      widget: {
        imageSize,
        utmMedium,
        utmSource,
        boxes,
        isNew
      }
    } = this.props

    const newLabel = activeDynamicLayout === DEVICES.MOBILE ? <NewLabelMobile/> : <NewLabelDesktop/>
    const headlineContent = isNew ? newLabel : null

    const utmParams = {
      utmSource,
      utmMedium
    }

    if (!boxes || !boxes.length) return null

    return (
      <WidgetContainer
        widget={widget}
        isOpening={isOpening}
        activeDynamicLayout={activeDynamicLayout}
        isOpen={isOpen}
        handleToggleContent={handleToggleContent}
        headlineContent={headlineContent}
        googleAnalytics={googleAnalytics}
        handleHeadlineClick={this.handleHeadlineClick}
      >
        <LeafletsContainer
          boxes={boxes}
          imageSize={imageSize}
          utmParams={utmParams}
          handleAnchorClick={this.handleAnchorClick.bind(this)}
          activeDynamicLayout={activeDynamicLayout}
        />
      </WidgetContainer>
    )
  }
}
